import { render, staticRenderFns } from "./CreateThisGroup.vue?vue&type=template&id=18ba70e6&"
import script from "./CreateThisGroup.vue?vue&type=script&lang=js&"
export * from "./CreateThisGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports